import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// Views
import Home from './views/Home.vue'
import UserAccount from './views/UserAccount.vue'
import User from './views/User.vue'
import Consignor from './views/Consignor.vue'
import Admin from './views/Admin.vue'
import Flip from './views/Flip.vue'
import Hold from './views/Hold.vue'
import FundingSoon from './views/FundingSoon.vue'
import FlipItem from './views/FlipItem.vue'
import FlipHistory from './views/FlipHistory.vue'
import FlipInvestors from './views/FlipInvestors.vue'
import Faq from './views/Faq.vue'
import BccModels from './views/BccModels.vue'
import TermsConditions from './views/TermsConditions.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import AboutUs from "./views/AboutUs"
// Components
import AssetList from './components/admin/AssetList.vue'
import AssetTypeList from './components/admin/AssetTypeList.vue'
import ConsignorList from './components/admin/ConsignorList.vue'
import UserList from './components/admin/UserList.vue'
import PayoutList from './components/admin/PayoutList.vue'
import PendingPaymentList from './components/admin/PendingPaymentList.vue'
import AssetForm from './components/admin/AssetForm.vue'
import AssetImageForm from './components/admin/AssetImageForm.vue'
import AssetDetails from './components/AssetDetails.vue'
import AdminReports from './components/admin/AdminReports.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // Homepage
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // FAQ
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    // FAQ
    {
      path: '/models',
      name: 'models',
      component: BccModels
    },
    // Terms - General
    {
      path: '/terms-conditions',
      name: 'termsConditions',
      component: TermsConditions
    },
    // Privacy Policy
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      component: AboutUs
    },
    // Hold placeholder
    {
      path: '/hold',
      name: 'hold',
      component: Hold
    },
    // FundingSoon placeholder
    {
      path: '/funding-soon',
      name: 'fundingSoon',
      component: FundingSoon
    },
    // Contact placeholder
    {
      path: '/contact',
      name: 'contact',
      component: Home
    },

    // --== Flip section ==--
    {
      path: '/flip',
      name: 'flip',
      component: Flip
    },
    {
      path: '/asset/:id',
      component: FlipItem,
      children: [
        {
          path: '',
          name: 'flipItem',
          component: AssetDetails
        },
        {
          path: 'investors',
          name: 'flipItemInvestors',
          meta: { requiresAdmin: true },
          component: FlipInvestors,
          beforeEnter: (to, from, next) => {
            // We're jumping into an admin section, so load the admin asset.
            store.dispatch('getAssetById', to.params.id).then(() => {
              next()
            })
          }
        },
        {
          path: 'history',
          name: 'flipItemHistory',
          meta: { requiresAdmin: true },
          component: FlipHistory,
          beforeEnter: (to, from, next) => {
            // We're jumping into an admin section, so load the admin asset.
            store.dispatch('getAssetById', to.params.id).then(() => {
              next()
            })
          }
        },
        {
          path: 'edit',
          name: 'flipItemEdit',
          meta: { requiresAdmin: true },
          component: AssetForm,
          beforeEnter: (to, from, next) => {
            // We're jumping into an admin section, so load the admin asset.
            store.dispatch('getAssetById', to.params.id).then(() => {
              next()
            })
          }
        },
        {
          path: 'images',
          name: 'flipItemEditImages',
          meta: { requiresAdmin: true },
          component: AssetImageForm,
          beforeEnter: (to, from, next) => {
            // We're jumping into an admin section, so load the admin asset.
            store.dispatch('getAssetById', to.params.id).then(() => {
              next()
            })
          }
        }
      ]
    },

    // Consignor Pages
    {
      path: '/consignor/:id',
      name: 'consignor',
      component: Consignor
    },

    // --== Admin Section ==--
    {
      path: '/admin',
      component: Admin,
      meta: { requiresAdmin: true },
      children: [
        {
          // Default redirect.
          path: '',
          name: 'admin',
          redirect: 'assets',
        },
        {
          path:'assets',
          name: 'adminAssets',
          component: AssetList
        },
        {
          path:'types',
          name: 'adminAssetTypes',
          component: AssetTypeList
        },
        {
          path:'consignors',
          name: 'adminConsignors',
          component: ConsignorList
        },
        {
          path:'users',
          name: 'adminUsers',
          component: UserList
        },
        {
          path:'withdrawals',
          name: 'adminPayout',
          component: PayoutList
        },
        {
          path:'pendingPayments',
          name: 'adminPendingPayments',
          component: PendingPaymentList
        },
        {
          path:'reports',
          name: 'adminReports',
          component: AdminReports
        }
      ]
    },

    // User Pages (admins only)
    {
      path: '/user/:id',
      name: 'user',
      meta: { requiresAdmin: true },
      component: User
    },

    // --== User Account Section ==--
    {
      path: '/account',
      name: 'userAccount',
      meta: { requiresAuth: true },
      component: UserAccount,
    },

    // Auth0 redirect target. Looking to receive a token to attempt login.
    {
      path: '/auth',
      name: 'auth',
      beforeEnter: (to, from, next) => {
        if (to.hash !== '') {
          // Token comes through the hash, so we need to parse it out.
          const hashBust = to.hash.split('=')
          if (hashBust[0] == '#id_token' && hashBust[1] !== '') {
            // Got a token, try to login.
            const token = hashBust[1].split('&')[0]
            store.dispatch('login', token).then(() => {
              // Success!

              // Grab the asset bounce cookie.
              // This should be set when a user was trying to perform
              // an asset action but were redirected to authenticate.
              let assetBounce = Vue.$cookies.get('assetBounce')

              if (!store.getters.profile.complete) {
                // Complete your profile!
                next('/account')
              }
              else if (assetBounce) {
                // We're bouncing, kill the cookie.
                Vue.$cookies.remove('assetBounce', '/')
                next(`/flip/${assetBounce}`)
              }
              else {
                // All good, flip it!
                next('/flip')
              }
            })
            .catch(() => {
              // Failed
              console.error('Login failed.')
              next('/')
            })
          }
          else {
            // We didn't find the token in the form we expect.
            console.error('Malformed token identifier.')
            next('/')
          }
        }

        // No token, you probably didn't mean to be here.
        // Redirect to home.
        console.error('No token.')
        next('/')
      }
    },
    {
      path: '*',
      beforeEnter: (to, from, next) => {
        console.error('Route not found, redirecting.')
        next('/')
      }
    }
  ]
})

// Do stuff before entering every route.
router.beforeEach((to, from, next) => {
  // Load new pages at top (might need less global solution)
  window.scrollTo(0, 0);
  // Check auth and populate the user store.
  // This is the 'me' call.
  store.dispatch('getAuthState').then(() => {

    /**
     * User check Navigation guards.
     * You can think of these like roles/permissions. This checks on route
     * metafields attached to a route. Presently there are two:
     *
     * - requiresAuth
     * - requiresAdmin
     *
     * This can be set on the route definition like so:
     *      meta: { requiresAdmin: true }
     */

    // Check if route requires authentication.
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.authenticated) {
        // Not authorized redirect home
        console.error('Access Denied.')
        next('/')
      }
    }

    // Check is route requires admin.
    else if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (!store.getters.user.admin) {
        // Not authorized redirect home
        console.error('Access Denied.')
        next('/')
      }
    }

    // Route has no nav guards, so keep going.
    next()
  })
})

export default router
